export const CHANGE_MAP = 'CHANGE_MAP'
export const CREATE_PLAYER = 'CREATE_PLAYER'
export const UPDATE_PLAYER = 'UPDATE_PLAYER'
export const DELETE_PLAYER = 'DELETE_PLAYER'
export const CREATE_BOT = 'CREATE_BOT'
export const DELETE_BOT = 'DELETE_BOT'
export const ADD_PLAYER_TO_ROOM = 'ADD_PLAYER_TO_ROOM'
export const REMOVE_PLAYER_FROM_ROOM = 'REMOVE_PLAYER_FROM_ROOM'
export const SWAP_PLAYER = 'SWAP_PLAYER'
export const SHUFFLE_PLAYER = 'SHUFFLE_PLAYER'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js